// Definice měřených veličin pro produkt "Měřené veličiny" (/station-group/meas-*)
// Každá položka = 1 chip v menu = 1 hodnota parametru "q" v GET /chart?type=stations&cfg=multi&q=...
// (viz doc/plans/station-group-meas.md sekce 1) = 1 sloupec tsId pro tabulku (daily_ts).
// "q" musí přesně odpovídat "q" v multi.json.quantities[].
export const STATIONS_CFG = 'multi'

export const MEAS_GRANULARITIES = [
  {
    key: '10m', obsType: '10M', label: '10minutová data',
    items: [
      { q: 'temp',      label: 'Teplota',                 tsId: '10M_TEMP',        unit: '°C'  },
      { q: 'precip',    label: 'Srážky',                  tsId: '10M_PRECIP',      unit: 'mm'  },
      { q: 'windspeed', label: 'Prům. rychlost větru',    tsId: '10M_WS',          unit: 'm/s' },
      { q: 'gust',      label: 'Max. nárazy větru',       tsId: '10M_WSMAX',       unit: 'm/s' },
      { q: 'press',     label: 'Tlak',                    tsId: '10M_PRESS',       unit: 'hPa' },
      { q: 'humid',     label: 'Vlhkost',                 tsId: '10M_RAWHUMIDITY', unit: '%'   },
      { q: 'tground',   label: 'Teplota přízemní',        tsId: '10M_TGROUND',     unit: '°C'  },
    ],
  },
  {
    key: 'hly', obsType: 'HLY', label: 'Hodinová data',
    items: [
      { q: 'hly-temp',      label: 'Teplota',              tsId: 'HLY_TEMP',        unit: '°C'  },
      { q: 'hly-precip',    label: 'Srážky',               tsId: 'HLY_PRECIP',      unit: 'mm'  },
      { q: 'hly-windspeed', label: 'Prům. rychlost větru', tsId: 'HLY_WSAVG',       unit: 'm/s' },
      { q: 'hly-gust',      label: 'Max. nárazy větru',    tsId: 'HLY_WSMAX',       unit: 'm/s' },
      { q: 'hly-press',     label: 'Tlak',                 tsId: 'HLY_PRESSSEA',    unit: 'hPa' },
      { q: 'hly-humid',     label: 'Vlhkost',              tsId: 'HLY_RAWHUMIDITY', unit: '%'   },
      { q: 'hly-tground',   label: 'Teplota přízemní',     tsId: 'HLY_TGROUND',     unit: '°C'  },
      { q: 'hly-tmax',      label: 'Teplota maximální',    tsId: 'HLY_TX',          unit: '°C'  },
      { q: 'hly-tmin',      label: 'Teplota minimální',    tsId: 'HLY_TN',          unit: '°C'  },
    ],
  },
  {
    key: 'dly', obsType: 'DLY', label: 'Denní data',
    items: [
      { q: 'dly-temp',      label: 'Teplota',              tsId: 'DLY_TEMPAVG',      unit: '°C'  },
      { q: 'dly-precip',    label: 'Srážky',               tsId: 'DLY_PRECIPSUM',    unit: 'mm'  },
      { q: 'dly-windspeed', label: 'Prům. rychlost větru', tsId: 'DLY_WSAVG',        unit: 'm/s' },
      { q: 'dly-gust',      label: 'Max. nárazy větru',    tsId: 'DLY_WSMAX',        unit: 'm/s' },
      { q: 'dly-snow',      label: 'Sníh',                 tsId: 'DLY_SNOW',         unit: 'cm'  },
      { q: 'dly-press',     label: 'Tlak',                 tsId: 'DLY_PRESSAVG',     unit: 'hPa' },
      { q: 'dly-humid',     label: 'Vlhkost',              tsId: 'DLY_RAWHUMIDITYAVG', unit: '%' },
      { q: 'dly-tmax',      label: 'Teplota maximální',    tsId: 'DLY_TXMAX',        unit: '°C'  },
      { q: 'dly-tmin',      label: 'Teplota minimální',    tsId: 'DLY_TNMIN',        unit: '°C'  },
      { q: 'dly-soil05',    label: 'Půdní teplota 5 cm',   tsId: 'DLY_SOIL05AVG',    unit: '°C'  },
      { q: 'dly-soil10',    label: 'Půdní teplota 10 cm',  tsId: 'DLY_SOIL10AVG',    unit: '°C'  },
      { q: 'dly-soil20',    label: 'Půdní teplota 20 cm',  tsId: 'DLY_SOIL20AVG',    unit: '°C'  },
      { q: 'dly-soil50',    label: 'Půdní teplota 50 cm',  tsId: 'DLY_SOIL50AVG',    unit: '°C'  },
      { q: 'dly-soil100',   label: 'Půdní teplota 100 cm', tsId: 'DLY_SOIL100AVG',   unit: '°C'  },
    ],
  },
]

// Rychlé vyhledání definice podle q (napříč všemi granularitami) — q je globálně unikátní slug,
// používá se jako slug v URL produktu (/station-group/meas-<q>) i jako query param q= v /chart.
export const MEAS_BY_SLUG = new Map(
  MEAS_GRANULARITIES.flatMap(g => g.items.map(item => [item.q, { ...item, obsType: g.obsType, granKey: g.key }]))
)

// Seznam produktů "Skupina stanic" (chipy v menu StationGroupLayout, sloupce v
// SaveProductFilterModal, zdroj pro admin správu skupin) je od
// doc/plans/product-registry-refactor.md (etapa 1) odvozen z centrálního registru —
// viz GROUP_PRODUCTS v src/config/productRegistry.js.

// Max. počet stanic zobrazených v 1 grafu (barevná paleta na serveru má jen 12 barev, nad tento
// počet by se barvy opakovaly a legenda by přeplnila graf — viz charts/stations/multi.json "colors").
export const MAX_STATIONS_PER_CHART = 12
